import React from 'react'

import assetUrl from 'src/utils/assetUrl'
import ProjectContent from './ProjectContent'

const nonprofitLogo = assetUrl(RAILS_ASSET_URL('/cpwm/nonprofit-logo.svg'))

const HomePanel = ({ project, title, charity }) =>
  <div className="d-flex flex-column min-vh-100">
    <div className="mb-auto">
      <ProjectContent
        project={project}
        suffix="Featured Rebuild"
      />
    </div>

    <div className="border-top t-spacing px-3 py-4 p-sm-5 p-lg-4 p-xl-5">
      <div className="d-flex align-items-center">
        <div className="mr-3">
          <img src={nonprofitLogo} alt={charity.name} height="68" />
        </div>

        <p className="text-black-50 mb-0">
          {title} is supporting {charity.name} projects across the country.
        </p>
      </div>
    </div>
  </div>

export default HomePanel
